import * as React from 'react';
import { BasenameContext } from "./BasenameContext.js";
/**
 * Set the string to append to all links to the admin app.
 *
 * Useful when the app is mounted on a sub path, e.g. '/admin'.
 * Used internally by the `<Admin>` component.
 *
 * @see useBasename
 */
export var BasenameContextProvider = function (_a) {
    var children = _a.children, basename = _a.basename;
    return (React.createElement(BasenameContext.Provider, { value: basename }, children));
};
//# sourceMappingURL=BasenameContextProvider.js.map